import UnderChartInfo from './UnderChartInfo';

export default UnderChartInfo;
